<template>
 <div className="video-responsive">
    <iframe
      :width="width"
      :height="height"
      :src="src + '?controls=0&mute=1&playsinline=1&showinfo=0&iv_load_policy=3&rel=0&cc_load_policy=0&autoplay=0&modestbranding=1&disablekb=1&fs=0'"
      allowFullScreen
      title="Embedded youtube"
    />
  </div>
</template>

<script>
    export default {
        name:'youtubeApp',
        props: {
          width: Number,
          height:Number,
          src:String
        },
    }
</script>